import Logger from '@/features/logger/classes/Logger';
import { container } from 'tsyringe';

export default container.resolve(Logger);
